/**
 * Variant Picker — Custom element for variant selection
 * Handles swatches, pills, and select dropdowns
 */
(function () {
  'use strict';

  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.masterSelect = this.querySelector('[data-master-select]');
      this.variantData = JSON.parse(
        this.querySelector('[data-variant-json]')?.textContent || '[]'
      );
      this.optionGroups = this.querySelectorAll('[data-option-group]');
      this.optionValueLabels = this.querySelectorAll('[data-option-value]');
      this.selects = this.querySelectorAll('[data-option-select]');
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
      this.selects.forEach((select) => {
        select.addEventListener('change', this.handleSelectChange.bind(this));
      });
    }

    handleClick(e) {
      const swatch = e.target.closest('[data-swatch]');
      const pill = e.target.closest('.variant-picker__pill');
      const target = swatch || pill;

      if (!target) return;
      if (target.disabled) return;

      e.preventDefault();
      e.stopPropagation();

      const optionIndex = parseInt(target.dataset.optionIndex);
      const value = target.dataset.value;

      this.selectOption(optionIndex, value);
    }

    handleSelectChange(e) {
      const select = e.target;
      const optionIndex = parseInt(select.dataset.optionIndex);
      const value = select.value;

      this.selectOption(optionIndex, value);
    }

    selectOption(optionIndex, value) {
      /* Update active states */
      const fieldset = this.querySelector(
        `[data-option-index="${optionIndex}"]`
      );
      if (!fieldset) return;

      const buttons = fieldset.querySelectorAll(
        '[data-swatch], .variant-picker__pill'
      );
      buttons.forEach((btn) => {
        btn.classList.toggle(
          'is-active',
          btn.dataset.value === value
        );
      });

      /* Update label */
      const label = fieldset.querySelector('[data-option-value]');
      if (label) label.textContent = value;

      /* Find matching variant */
      const selectedOptions = this.getSelectedOptions();
      const variant = this.findVariant(selectedOptions);

      if (variant) {
        this.masterSelect.value = variant.id;
        this.updateAvailability(selectedOptions);

        SixSeven.emit(SixSeven.Events.VARIANT_CHANGED, {
          variant,
          sectionId: this.dataset.section,
        });
      }
    }

    getSelectedOptions() {
      const options = [];
      this.querySelectorAll('.variant-picker__option').forEach(
        (fieldset, index) => {
          const activeSwatch = fieldset.querySelector(
            '[data-swatch].is-active, .variant-picker__pill.is-active'
          );
          const select = fieldset.querySelector('[data-option-select]');

          if (activeSwatch) {
            options[index] = activeSwatch.dataset.value;
          } else if (select) {
            options[index] = select.value;
          }
        }
      );
      return options;
    }

    findVariant(selectedOptions) {
      return this.variantData.find((variant) => {
        return variant.options.every(
          (opt, index) => opt === selectedOptions[index]
        );
      });
    }

    updateAvailability(selectedOptions) {
      this.querySelectorAll('.variant-picker__option').forEach(
        (fieldset, optionIndex) => {
          const buttons = fieldset.querySelectorAll(
            '.variant-picker__pill'
          );
          buttons.forEach((btn) => {
            const testOptions = [...selectedOptions];
            testOptions[optionIndex] = btn.dataset.value;

            const matchingVariant = this.variantData.find((v) =>
              v.options.every(
                (opt, i) => opt === testOptions[i]
              )
            );

            const available = matchingVariant && matchingVariant.available;
            btn.classList.toggle('is-unavailable', !available);
            btn.disabled = !available;
          });
        }
      );
    }
  }

  customElements.define('variant-picker', VariantPicker);
})();
